export const baseUrl = "https://wingu.api.hrl.sandboxaddis.com/api";
export const googleApi = "https://storage.googleapis.com/hris-lisence-dev/";